import React from 'react';
import { WidgetProvider, Widget } from '@rango-dev/widget-embedded';
import { widgetConfig } from 'config/widgetConfig';

function Swap() {
  return (
    <WidgetProvider config={widgetConfig}>
      {/* 
        Animated gradient background:
        - We apply a linear gradient with multiple color stops.
        - backgroundSize: "400% 400%" ensures the gradient is "bigger" than the container,
          allowing the animation to shift the gradient across the screen.
        - animation: "gradientBG 15s ease infinite" references our keyframes.
      */}
      <div
        style={{
          background: 'linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab)',
          backgroundSize: '400% 400%',
          animation: 'gradientBG 15s ease infinite',
        }}
        className="relative min-h-screen flex items-center justify-center overflow-hidden"
      >
        {/* 
          Inline style block for keyframes if you don’t have a global CSS:
          (Remove this <style> if you already placed the keyframes in your global CSS.)
        */}
        <style jsx>{`
          @keyframes gradientBG {
            0% {
              background-position: 0% 50%;
            }
            50% {
              background-position: 100% 50%;
            }
            100% {
              background-position: 0% 50%;
            }
          }
        `}</style>


    
        {/*
        <div className="absolute w-96 h-96 bg-[#e73c7e] rounded-full opacity-30 filter blur-3xl mix-blend-multiply animate-pulse -top-32 -left-32" />
        <div className="absolute w-80 h-80 bg-indigo-500 rounded-full opacity-30 filter blur-3xl mix-blend-multiply -bottom-32 -right-32" />*/}

        {/* 
          Center the swap widget.
          No extra styling needed if you want the widget to remain unchanged.
        */}
        <div className="relative z-10 p-4">
          <Widget config={widgetConfig} />
        </div>
      </div>
    </WidgetProvider>
  );
}

export default Swap;
